import { useEffect } from "react";

/** Update <title>, meta description, and canonical link for SEO on route changes. */
export default function useSeo({ title, description, image, canonical } = {}) {
    useEffect(() => {
        if (title) document.title = title;
        setMeta("description", description);
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");
        if (image) setMeta("og:image", image, "property");
        setCanonical(canonical);
    }, [title, description, image, canonical]);
}

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(href) {
    if (!href) return;
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}
